const LS_KEY_NAME = 'product_import_upload_id'

export const setProductImportIdtoLs = (id) => localStorage.setItem(LS_KEY_NAME, id)
export const getProductImportIdFromLs = () => localStorage.getItem(LS_KEY_NAME)
export const removeProductImportIdFromLs = () => localStorage.removeItem(LS_KEY_NAME)
